import { create } from 'zustand';
import { AdminEventPlayerType, LocationType, VideoUploadOption } from 'types/admin/trackmanEventsAdmin';

type CommonState = {
  loading: boolean;
  title: string;
  meetingUrl: string;
  location: string;
  locationType: LocationType;
  startDate: string;
  recordingReady: boolean;
  imageUrl: string;
  videoId: string;
  videoUrl: string;
  visible: boolean;
  videoLengthHours: string;
  videoLengthMinutes: string;
  videoUploadOption: VideoUploadOption;
  previewImageData: File | null;
  premiumEvent: boolean;
  playerType: AdminEventPlayerType;
};

type AddState = CommonState;

type EditState = CommonState & {
  id: string;
};

type State = AddState | EditState;

type Actions = {
  setLoading: (loading: boolean) => void;
  initAdd: () => void;
  initEdit: (id: string) => void;
  setTitle: (title: string) => void;
  setMeetingUrl: (meetingUrl: string) => void;
  setLocation: (location: string) => void;
  setLocationType: (locationType: LocationType) => void;
  setStartDate: (startDate: string) => void;
  setRecordingReady: (recordingReady: boolean) => void;
  setVideoId: (videoId: string) => void;
  setVideoUrl: (videoUrl: string) => void;
  setVisible: (visible: boolean) => void;
  setVideoLengthHours: (videoLengthHours: string) => void;
  setVideoLengthMinutes: (videoLengthMinutes: string) => void;
  setVideoUploadOption: (videoUploadOption: VideoUploadOption) => void;
  setPreviewImageData: (previewImageData: File | null) => void;
  setImageUrl: (imageUrl: string) => void;
  setPremiumEvent: (premiumEvent: boolean) => void;
  setPlayerType: (playerType: AdminEventPlayerType) => void;
  resetState: () => void;
};

export type { AddState, EditState, State };

const defaultCommonState: CommonState = {
  loading: false,
  title: '',
  meetingUrl: '',
  location: '',
  locationType: 'Online',
  startDate: '',
  recordingReady: false,
  imageUrl: '',
  videoId: '',
  videoUrl: '',
  visible: false,
  videoLengthHours: '',
  videoLengthMinutes: '',
  videoUploadOption: 'videoId',
  previewImageData: null,
  premiumEvent: false,
  playerType: 'Youtube',
};

export const useTrackmanEventsEditorStore = create<State & Actions>((set) => ({
  ...defaultCommonState,
  setLoading: (loading) => set(() => ({ loading })),
  initAdd: () => set(() => ({ ...defaultCommonState })),
  initEdit: (id) => set(() => ({ ...defaultCommonState, id })),
  setTitle: (title) => set(() => ({ title })),
  setMeetingUrl: (meetingUrl) => set(() => ({ meetingUrl })),
  setLocation: (location) => set(() => ({ location })),
  setLocationType: (locationType) => set(() => ({ locationType })),
  setStartDate: (startDate) => set(() => ({ startDate })),
  setRecordingReady: (recordingReady) => set(() => ({ recordingReady })),
  setImageUrl: (imageUrl) => set(() => ({ imageUrl })),
  setVideoId: (videoId) => set(() => ({ videoId })),
  setVideoUrl: (videoUrl) => set(() => ({ videoUrl })),
  setVisible: (visible) => set(() => ({ visible })),
  setVideoLengthHours: (videoLengthHours) => set(() => ({ videoLengthHours })),
  setVideoLengthMinutes: (videoLengthMinutes) => set(() => ({ videoLengthMinutes })),
  setVideoUploadOption: (videoUploadOption) => set(() => ({ videoUploadOption })),
  setPreviewImageData: (previewImageData) => set(() => ({ previewImageData })),
  setPremiumEvent: (premiumEvent) => set(() => ({ premiumEvent })),
  setPlayerType: (playerType) => set(() => ({ playerType })),
  resetState: () => set(() => ({ ...defaultCommonState })),
}));
